(function() {
  "use strict";

  angular.module("sempraWebapp").component("businessTransactions", {
    templateUrl:
      "app/periodicSummary/businessTransactions/businessTransactions.html",
    controller: businessTransactionsController,
    bindings: {
      activate: "<"
    },
    controllerAs: "vm"
  });

  function businessTransactionsController(
    periodicSummaryActions,
    $log,
    getMonthsService,
    $filter,
    $translate
  ) {
    var vm = this;

    // GRID CONFIIG
    vm.businessTransactionData = [];
    vm.businessTransactionOrderBy = "";
    vm.businessTransactionOrder = "desc";
    vm.businessTransactionPage = 1;
    vm.businessTransactionTotal = 0;
    vm.businessTransactionPageSize = 10;
    vm.businessTransactionPageOptions = [10, 20];
    vm.selectedbusinessTransaction = [];
    vm.pagerTranslations = {
      page: $translate.instant("GRID_PAGER_PAGE"),
      rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
      of: $translate.instant("GRID_PAGER_PAGE_OF")
    };

    vm.yearList = getYearList();
    vm.selectFromMonth = 0;
    vm.selectToMonth = new Date().getMonth();
    vm.selectYear = vm.currentYear = new Date().getFullYear();
    vm.currentMonth = new Date().getMonth() + 1;
    vm.checkAfterSearch = true;

    vm.createToMonthList = function(fromMonth, toMOnth) {
      var selectedMonth = $filter("monthToStringFilter")(fromMonth + 1);
      var indexOfSelectedMonth = vm.monthList.indexOf(selectedMonth);
      vm.monthToList = vm.monthList.slice(fromMonth);
      vm.selectToMonthIndex = indexOfSelectedMonth;
      vm.disableSearch = fromMonth > toMOnth ? true : false;
    };

    vm.checkSearchCriteria = function(fromMonth, toMOnth) {
      vm.disableSearch = fromMonth > toMOnth ? true : false;
    };

    vm.sortChanged = function(order) {
      var orderQuery = getOrderObject(order);
      vm.businessTransactionOrderBy = orderQuery.orderBy;
      vm.businessTransactionOrder = orderQuery.order;
      refreshBusinessInvoices();
    };

    vm.pageChanged = function(page, limit) {
      vm.businessTransactionPage = page;
      vm.businessTransactionPageSize = limit;
      vm.sortChanged(vm.businessTransactionOrderBy);
    };

    vm.search = function() {
      vm.businessTransactionPage = 1;
      vm.checkAfterSearch = vm.selectYear === vm.currentYear ? true : false;
      refreshBusinessInvoices();
    };

    vm.downloadBusinessInvoice = function(id, month) {
      periodicSummaryActions
        .downloadBusinessInvoice(id, month, vm.selectYear)
        .then(function(data) {
          var invoiceTitle = data.headers().pdfname;

          var file = new Blob([data.data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);

          var file_path = fileURL;
          /* eslint-disable */
          var a = document.createElement("A");
          a.href = file_path;
          a.download = invoiceTitle;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          /* eslint-enable */
        });
    };

    function refreshBusinessInvoices() {
      vm.promise = periodicSummaryActions
        .getBusinessTransactions(
          vm.selectFromMonth + 1,
          vm.selectToMonth + 1,
          vm.selectYear,
          vm.businessTransactionOrderBy,
          vm.businessTransactionOrder,
          vm.businessTransactionPage - 1,
          vm.businessTransactionPageSize
        )
        .then(
          function(data) {
            vm.businessInvoices = data.content.map(function(item) {
              item.disableSearch =
                item.month === vm.currentMonth &&
                vm.selectYear === vm.currentYear
                  ? true
                  : false;
              return item;
            });
            vm.businessTransactionTotal = data.totalElements;
          },
          function(errorData) {
            $log.log("an error occured" + errorData);
          }
        );
    }

    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    refreshBusinessInvoices();

    //Create year list
    function getYearList() {
      var list = [];
      var currentYear = new Date().getFullYear();
      for (var i = 2015; i < currentYear + 1; i++) {
        list.push(i);
      }
      return list.reverse();
    }

    //Get month list from moment locale (via getMonths service)
    this.monthList = getMonthsService.getMonthList();
    this.monthToList = getMonthsService.getMonthList();
  }
})();
